var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_8410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.94764 12.0012C5.88214 12.0012 5.81814 11.9752 5.77064 11.9282C5.71164 11.8692 5.68564 11.7842 5.70214 11.7027L6.05564 9.93522C6.06564 9.88622 6.08864 9.84172 6.12414 9.80722L10.0131 5.91822C10.3051 5.62622 10.7816 5.62622 11.0736 5.91822L11.7806 6.62522C12.0731 6.91772 12.0731 7.39322 11.7806 7.68572L7.89164 11.5747C7.85714 11.6097 7.81264 11.6332 7.76364 11.6432L5.99614 11.9967C5.98014 11.9997 5.96364 12.0012 5.94764 12.0012V12.0012ZM6.53164 10.1067L6.26664 11.4322L7.59214 11.1672L11.4276 7.33172C11.5251 7.23422 11.5251 7.07572 11.4276 6.97822L10.7206 6.27122C10.6231 6.17372 10.4646 6.17372 10.3671 6.27122L6.53164 10.1067ZM7.71514 11.3977H7.72014H7.71514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10.5H1.25C0.5605 10.5 0 9.9395 0 9.25V2.75C0 2.0605 0.5605 1.5 1.25 1.5H2.25C2.388 1.5 2.5 1.612 2.5 1.75C2.5 1.888 2.388 2 2.25 2H1.25C0.8365 2 0.5 2.3365 0.5 2.75V9.25C0.5 9.6635 0.8365 10 1.25 10H4.75C4.888 10 5 10.112 5 10.25C5 10.388 4.888 10.5 4.75 10.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 6C8.112 6 8 5.888 8 5.75V2.75C8 2.3365 7.6635 2 7.25 2H6.25C6.112 2 6 1.888 6 1.75C6 1.612 6.112 1.5 6.25 1.5H7.25C7.9395 1.5 8.5 2.0605 8.5 2.75V5.75C8.5 5.888 8.388 6 8.25 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3H2.75C2.3365 3 2 2.6635 2 2.25V1.25C2 1.112 2.112 1 2.25 1H3.025C3.141 0.43 3.6465 0 4.25 0C4.8535 0 5.359 0.43 5.475 1H6.25C6.388 1 6.5 1.112 6.5 1.25V2.25C6.5 2.6635 6.1635 3 5.75 3ZM2.5 1.5V2.25C2.5 2.3875 2.6125 2.5 2.75 2.5H5.75C5.8875 2.5 6 2.3875 6 2.25V1.5H5.25C5.112 1.5 5 1.388 5 1.25C5 0.8365 4.6635 0.5 4.25 0.5C3.8365 0.5 3.5 0.8365 3.5 1.25C3.5 1.388 3.388 1.5 3.25 1.5H2.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 4.5H1.75C1.612 4.5 1.5 4.388 1.5 4.25C1.5 4.112 1.612 4 1.75 4H6.75C6.888 4 7 4.112 7 4.25C7 4.388 6.888 4.5 6.75 4.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6H1.75C1.612 6 1.5 5.888 1.5 5.75C1.5 5.612 1.612 5.5 1.75 5.5H6.75C6.888 5.5 7 5.612 7 5.75C7 5.888 6.888 6 6.75 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 7.5H1.75C1.612 7.5 1.5 7.388 1.5 7.25C1.5 7.112 1.612 7 1.75 7H6.75C6.888 7 7 7.112 7 7.25C7 7.388 6.888 7.5 6.75 7.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_8410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.519f6a0a8f0212d05d86923b6052a80c.svg";
export { ForwardRef as ReactComponent };